// extracted by mini-css-extract-plugin
export default {"iconPremium":"IconPremiumGold_iconPremium__Bb5I-","bg":"IconPremiumGold_bg__0sLtz"};